import styled from 'styled-components';
import {device} from 'styled/device';

export const ModalStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 370px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px 0;
  gap: 20px;

  @media (max-width: ${device.mobileL}) {
    flex-direction: column;
    align-items: center;
    padding: 30px 0 0;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  .modalTitle {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 30px;
    font-weight: 400;
    color: #23262f;
    padding: 20px 0 30px 0;
  }

  @media (max-width: ${device.mobileM}) {
    .desktopImage {
      display: none;
    }
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const WrapperCopyLink = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`;

export const InputShareLink = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 25px;
  padding: 0 100px 0 20px;
  border: 1px solid #ced7e5;
  outline: none;
  text-align: left;
  font-size: 16px;
  color: #141416;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  :focus {
    outline: none;
  }
`;

export const ButtonCopy = styled.button`
  position: absolute;
  right: 0;
  z-index: 2;
  border: 2px solid #e6e8ec;
  background-color: white;
  height: 32px;
  padding: 0 10px;
  margin-right: 10px;
  box-sizing: border-box;
  border-radius: 26px;
  text-transform: capitalize;
  font-size: 14px;
  color: #23262f;
  cursor: pointer;
  transition: all 0.07s ease-in-out;

  &:hover {
    border: 2px solid #353945;
    background-color: #353945;
    color: white;
  }
`;

export const LinkCopiedMessage = styled.div`
  font-size: 20px;
  color: #161643;
  margin-top: 16px;
  height: 35px;
  cursor: default;
`;

export const LinkBlackButton = styled.div`
  display: flex;
  align-items: center;
  height: 35px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  padding: 0 30px;
  background-color: #353945;
  border-radius: 26px;
  border: 2px solid #353945;

  :hover {
    color: #23262f;
    background-color: white;
    border: 2px solid #b1b5c4;
  }
`;
